import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { AdyenCheckoutWrapper } from './AdyenCheckoutWrapper';
import { CheckoutComCheckoutWrapper } from './CheckoutComCheckoutWrapper';

/**
 * Renders the correct payment drop-in based on the PaymentProvider AB test group
 */
export const PaymentCheckoutWrapper = observer(() => {
  const { paymentProvider } = useUserStore();

  if (paymentProvider === 'CHECKOUT_COM') {
    return <CheckoutComCheckoutWrapper />;
  }

  return <AdyenCheckoutWrapper />;
});
